import { track_ga } from '@/pages/firebase'

//banner曝光
export const bannerShow = (index, id) => {
  setTimeout(() => {
    track_ga('home_banner_show', {
      page: 'home',
      banner_id: index,
      list_id: id,
    })
  }, 1500)
}

//banner点击
export const bannerClick = (index, id) => {
  track_ga('home_banner_click', {
    page: 'home',
    banner_id: index,
    list_id: id,
  })
}

//列表内容曝光
export const listShow = (params) => {
  track_ga('home_list_show', {
    page: 'home',
    ...params,
  })
}

//列表内容点击
export const listClick = (params) => {
  track_ga('home_list_click', {
    page: 'home',
    ...params,
  })
}
